import * as AppPics from 'assets/images';
import Icons from '../../assets/Icons';

function Html() {
  return (
    <div className="mainWraper">
      <div className="tab">
        <ul className="tab__menu">
          <li className="back">
            <button className="btn-back">
              <img src={AppPics.BackSvg} alt="" />
            </button>
          </li>
          <li className="active">Quiz</li>
          <li>NCERT Answered</li>
          <li>Previous Year Questions</li>
        </ul>
        <div className="tab__content p-0">
          <div className="tab__content-actHead">
            <h3 className="boldtitle mt-2">
              Physics <span>&#62;</span> Waves
            </h3>
            <button className="btn-plane">AS Level</button>
            <button className="btn-plane green">AQA</button>
            <img className="country_tag" src={AppPics.UkFlagSvg} alt="" />
          </div>
          <div className="tab__content-actBody">
            <div className="px-5">
              <div className="row justify-content-end my-4 ">
                <div className="offset-10 col-md-2 col-lg-2 col-sm-12">
                  <button className="btn-plane g--tint floatright">+ New Question</button>
                </div>
              </div>
              <div
                class="modal fade show app-l-modal"
                id="exampleModal"
                tabindex="-1"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
                style={{ display: 'block' }}
              >
                <div class="modal-dialog modal-dialog-centered">
                  <div class="modal-content">
                    <div class="modal-header">
                      DELETE Sub Lesson
                      <button
                        type="button"
                        class="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div class="modal-body">
                      <p className="modal-sub-text">
                        Are you sure you want to delete this Sub Lesson?{' '}
                      </p>
                      <div className="app-l-modal-btn-block">
                        <button type="button" class="btn-plane p--tint mx-4">
                          Yes*
                        </button>
                        <button type="button" class="btn-plane p--tint mx-4">
                          NO
                        </button>
                      </div>
                      <p className="modal-sub-note">
                        *Please note that this action is irreversible
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="app-l-icon-popover-wrapper relative mb-5">
                <div className="app-l-icon-popover d-flex align-items-center justify-content-center">
                  <button type="button" class="btn btn-link">
                    <Icons.addChatIcon />
                  </button>
                  <button type="button" class="btn btn-link">
                    <Icons.expandIcon />
                  </button>
                  <button type="button" class="btn btn-link">
                    <Icons.editIcon />
                  </button>
                  <button type="button" class="btn btn-link">
                    <Icons.deleteIcon />
                  </button>
                  <button type="button" class="btn btn-link">
                    <Icons.imageEditIcon />
                  </button>
                </div>
                <div className="app-l-icon-popover-wrapper__downArrow">
                  <Icons.downArrow />
                </div>
              </div>
              <div class="card text-center app-l-comments-wrapper">
                <div class="card-header">COMMENTS & ACTIVITY</div>
                <div class="card-body">
                  <ul class="list-group list-group-flush">
                    <li class="list-group-item">
                      <img src={AppPics.AvatarSVG} alt="Avatar" />
                      <div>
                        <span>
                          Can you please let me know how to correct this grammatical mistake?
                        </span>
                        <span>March 26, 09:22 AM</span>
                      </div>
                    </li>
                    <li class="list-group-item">
                      <img src={AppPics.AvatarSVG} alt="Avatar" />
                      <div>
                        <span>
                          Can you please let me know how to correct this grammatical mistake?
                        </span>
                        <span>March 26, 09:22 AM</span>
                      </div>
                    </li>{' '}
                    <li class="list-group-item">
                      <img src={AppPics.AvatarSVG} alt="Avatar" />
                      <div>
                        <span>
                          Can you please let me know how to correct this grammatical mistake?
                        </span>
                        <span>March 26, 09:22 AM</span>
                      </div>
                    </li>{' '}
                    <li class="list-group-item">
                      <img src={AppPics.AvatarSVG} alt="Avatar" />
                      <div>
                        <span>
                          Can you please let me know how to correct this grammatical mistake?
                        </span>
                        <span>March 26, 09:22 AM</span>
                      </div>
                    </li>{' '}
                    <li class="list-group-item">
                      <img src={AppPics.AvatarSVG} alt="Avatar" />
                      <div>
                        <span>
                          Can you please let me know how to correct this grammatical mistake?
                        </span>
                        <span>March 26, 09:22 AM</span>
                      </div>
                    </li>{' '}
                    <li class="list-group-item">
                      <img src={AppPics.AvatarSVG} alt="Avatar" />
                      <div>
                        <span>
                          Can you please let me know how to correct this grammatical mistake?
                        </span>
                        <span>March 26, 09:22 AM</span>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="w-50 p-3">
                <div className="d-flex align-items-center">
                  <span className="radioBlock">
                    <input id="questype1" name="test" value="2" type="radio" checked />
                    <label htmlFor="questype1">Multiple Choice Question having</label>
                  </span>
                </div>
                <div className="w-75 p-3">
                  <select required>
                    <option value="" selected="" disabled="">
                      Choose
                    </option>
                    <option value="1">Only One Correct Answer</option>
                    <option value="2">More than One Correct Answer</option>
                  </select>
                </div>
              </div>

              <div className="w-50 p-3">
                <div className="d-flex align-items-center">
                  <span className="radioBlock">
                    <input id="questype2" name="test" value="2" type="radio" />
                    <label htmlFor="questype2">Fill In the Blanks Question</label>
                  </span>
                </div>
              </div>

              <div className="w-50 p-3">
                <div className="d-flex align-items-center">
                  <span className="radioBlock">
                    <input id="questype3" name="test" value="2" type="radio" />
                    <label htmlFor="questype3">Match the Following Question</label>
                  </span>
                </div>
              </div>

              <div className="w-50 p-3">
                <div className="d-flex align-items-center">
                  <span className="radioBlock">
                    <input id="questype4" name="test" value="2" type="radio" />
                    <label htmlFor="questype4">Short Answer Question</label>
                  </span>
                </div>
              </div>

              <div className="row mt-4">
                <div className="col-md-12 col-lg-12 col-sm-12">
                  <div className="lessonWrap lessonWrap--border topalign">
                    <label htmlFor="">QUESTION #1 </label>
                    <button className="lessonWrap__btn floatright mr-4">
                      <img src={AppPics.DownArrowSvg} alt="" />
                    </button>
                    <div className="w-50 p-3">
                      <div className="d-flex align-items-center">
                        <span className="radioBlock">
                          <input id="questype1" name="test1" value="3" type="radio" checked />
                          <label htmlFor="questype1">Multiple Choice Question having</label>
                        </span>
                      </div>
                      <div className="w-75 p-3">
                        <select required>
                          <option value="1" selected="">
                            Only One Correct Answer
                          </option>
                          <option value="2">More than One Correct Answer</option>
                        </select>
                      </div>
                    </div>

                    <div className="w-100 p-3">
                      <label htmlFor="">Question</label>
                      <textarea
                        name=""
                        id=""
                        cols="20"
                        placeholder="Enter only the question here. You can select the correct answer(s) in the next field"
                      ></textarea>
                    </div>

                    <div className="lessonWrap  topalign py-0">
                      <div className="w-100 p-3">
                        <label htmlFor="">Choice #1</label>
                        <span className="radioBlock floatright">
                          <input id="choice1" name="test2" value="2" type="radio" />
                          <label htmlFor="choice1">This is the correct Answer</label>
                        </span>

                        <button className="lessonWrap__btn leftpos edit">
                          <img src={AppPics.EditSvg} alt="" />
                        </button>
                        <button className="lessonWrap__btn leftpos dublicate">
                          <img src={AppPics.CopySvg} alt="" />
                        </button>
                        <button className="lessonWrap__btn leftpos delete">
                          <img src={AppPics.DeleteSvg} alt="" />
                        </button>
                        <textarea
                          name=""
                          id=""
                          cols="20"
                          placeholder="Enter only the question here. You can select the correct answer(s) in the next field"
                        ></textarea>
                      </div>
                    </div>

                    <div className="lessonWrap  topalign py-0">
                      <div className="w-100 p-3">
                        <label htmlFor="">Choice #2</label>
                        <span className="radioBlock floatright">
                          <input id="choice2" name="test2" value="2" type="radio" checked />
                          <label htmlFor="choice2">This is the correct Answer</label>
                        </span>

                        <button className="lessonWrap__btn leftpos edit">
                          <img src={AppPics.EditSvg} alt="" />
                        </button>
                        <button className="lessonWrap__btn leftpos dublicate">
                          <img src={AppPics.CopySvg} alt="" />
                        </button>
                        <button className="lessonWrap__btn leftpos delete">
                          <img src={AppPics.DeleteSvg} alt="" />
                        </button>
                        <textarea
                          name=""
                          id=""
                          cols="20"
                          placeholder="Enter only the question here. You can select the correct answer(s) in the next field"
                        ></textarea>
                      </div>
                    </div>

                    <div className="col-md-2 col-lg-2 col-sm-12">
                      <button className="btn-plane p--tint m-l-btn">+ Add Choice</button>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row mt-4">
                <div className="col-md-12 col-lg-12 col-sm-12">
                  <div className="lessonWrap lessonWrap--border topalign">
                    <label htmlFor="">QUESTION #2 </label>
                    <button className="lessonWrap__btn floatright mr-4">
                      <img src={AppPics.DownArrowSvg} alt="" />
                    </button>
                    <div className="w-50 p-3">
                      <div className="d-flex align-items-center">
                        <span className="radioBlock">
                          <input id="questype1" name="test1" value="3" type="radio" checked />
                          <label htmlFor="questype1">Multiple Choice Question having</label>
                        </span>
                      </div>
                      <div className="w-75 p-3">
                        <select required>
                          <option value="1">Only One Correct Answer</option>
                          <option value="2" selected="">
                            More than One Correct Answer
                          </option>
                        </select>
                      </div>
                    </div>

                    <div className="w-100 p-3">
                      <label htmlFor="">Question</label>
                      <textarea
                        name=""
                        id=""
                        cols="20"
                        placeholder="Enter only the question here. You can select the correct answer(s) in the next field"
                      ></textarea>
                    </div>

                    <div className="lessonWrap  topalign py-0">
                      <div className="w-100 p-3">
                        <label htmlFor="">Choice #1</label>
                        <span className="checkBlock floatright">
                          <input type="checkbox" id="1" />
                          <label htmlFor="1">This is a correct Answer</label>
                        </span>

                        <button className="lessonWrap__btn leftpos edit">
                          <img src={AppPics.EditSvg} alt="" />
                        </button>
                        <button className="lessonWrap__btn leftpos dublicate">
                          <img src={AppPics.CopySvg} alt="" />
                        </button>
                        <button className="lessonWrap__btn leftpos delete">
                          <img src={AppPics.DeleteSvg} alt="" />
                        </button>
                        <textarea
                          name=""
                          id=""
                          cols="20"
                          placeholder="Enter only the question here. You can select the correct answer(s) in the next field"
                        ></textarea>
                      </div>
                    </div>

                    <div className="lessonWrap  topalign py-0">
                      <div className="w-100 p-3">
                        <label htmlFor="">Choice #2</label>
                        <span className="checkBlock floatright">
                          <input type="checkbox" id="2" />
                          <label htmlFor="2">This is a correct Answer</label>
                        </span>

                        <button className="lessonWrap__btn leftpos edit">
                          <img src={AppPics.EditSvg} alt="" />
                        </button>
                        <button className="lessonWrap__btn leftpos dublicate">
                          <img src={AppPics.CopySvg} alt="" />
                        </button>
                        <button className="lessonWrap__btn leftpos delete">
                          <img src={AppPics.DeleteSvg} alt="" />
                        </button>
                        <textarea
                          name=""
                          id=""
                          cols="20"
                          placeholder="Enter only the question here. You can select the correct answer(s) in the next field"
                        ></textarea>
                      </div>
                    </div>

                    <div className="col-md-2 col-lg-2 col-sm-12">
                      <button className="btn-plane p--tint m-l-btn">+ Add Choice</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="mb-5 btnTab-foot mt-5">
            <button className="btn-right-content save">Save Changes</button>
          </div>

          <div
            className="modal fade uploaddialogfade reportdialog"
            id="exampleModal"
            tabIndex="-1"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-dialog-centered uploaddialog">
              <div className="modal-content p-4">
                <div className="modal-head">
                  <h2 className="popuptitle">Report</h2>
                  <button
                    type="button"
                    className="btn btn-primary cancelbtn"
                    data-bs-dismiss="modal"
                  >
                    <img src={AppPics.CloseSvg} alt="" />
                  </button>
                </div>
                <div className="modal-body p-0">
                  <div className="container p-0 __review__blocks_quotes">
                    <blockquote>
                      <p>
                        The public is more familiar with bad design than good design. It is, in
                        effect, conditioned to prefer bad design, because that is what it lives
                        with. The new becomes threatening, the old reassuring.
                      </p>{' '}
                    </blockquote>
                    <div className="commentsection">
                      <div className="w-100 mt-4">
                        <label>
                          Select Issue <span>*</span>
                        </label>
                        <select required="">
                          <option value="" selected="" disabled="">
                            Choose
                          </option>
                          <option value="1">Test1</option>
                          <option value="2">Test2</option>
                          <option value="3">Test3</option>
                        </select>
                      </div>
                      <div className="w-100 mt-4 ">
                        <label htmlFor="">Comments</label>
                        <textarea name="" id="" cols="20"></textarea>
                      </div>
                      <button type="button" className="btn btn-primary savebutton mt-4">
                        Save
                      </button>
                    </div>
                    <div className="jumbotron m-0 p-0 bg-transparent mt-3">
                      <div className="row m-0 p-0 ">
                        <div className="col-12 p-0 m-0 ">
                          <div className="card border-0 rounded">
                            <div className="card-header p-1 bg-light border border-top-0 border-left-0 border-right-0">
                              <h4 className="float-left">
                                {' '}
                                <span className="mx-2">Issue :</span>
                                <span>Remove part</span>
                              </h4>
                              <p className="float-left">
                                {' '}
                                <span className="mx-2">Comments :</span>
                                <span>A Remove part is added here</span>
                              </p>

                              <img className="tickicon" src={AppPics.TickMarkSvg} alt="" />

                              {/* <div className="dropdown show">
											<a id="dropdownMenuLink" data-toggle="dropdown" className="btn btn-sm float-right text-secondary dddot" role="button">
                      <img  src={AppPics.DotSvg} alt="" />
											</a>
											<div className="chatedit dropdown-menu dropdown-menu-right border p-0" aria-labelledby="dropdownMenuLink"> 
											<a className="dropdown-item p-2 text-secondary px-3" href="#">Edit</a>
												<hr className="my-1"></hr> <a className="dropdown-item p-2 text-secondary px-3" href="#">Delete </a> </div>
										</div>  */}
                            </div>
                            <div className="card bg-sohbet border-0 m-0 p-4 px-5">
                              <div
                                id="sohbet"
                                className="card border-0 m-0 p-0 position-relative bg-transparent"
                              >
                                <div className="balon2 p-2 m-0 position-relative">
                                  {' '}
                                  <span className="float-left sohbet2">
                                    <span>Checking out iOS7 you know..</span>
                                    {/* <div className="dropdown show">
											<a id="dropdownMenuLink" data-toggle="dropdown" className="btn btn-sm float-right text-secondary dddot" role="button">
                      <img  src={AppPics.DotSvg} alt="" />
											</a>
											<div className="chatedit dropdown-menu dropdown-menu-right border p-0" aria-labelledby="dropdownMenuLink"> 
											<a className="dropdown-item p-2 text-secondary px-3" href="#">Edit</a>
												<hr className="my-1"></hr> <a className="dropdown-item p-2 text-secondary px-3" href="#">Delete </a> </div>
										</div>*/}
                                  </span>
                                </div>

                                <div className="balon2 p-2 m-0 position-relative">
                                  {' '}
                                  <span className="float-left sohbet2">
                                    <span>It's pretty cool!</span>
                                    {/* <div className="dropdown show">
											<a id="dropdownMenuLink" data-toggle="dropdown" className="btn btn-sm float-right text-secondary dddot" role="button">
                      <img  src={AppPics.DotSvg} alt="" />
											</a>
											<div className="chatedit dropdown-menu dropdown-menu-right border p-0" aria-labelledby="dropdownMenuLink"> 
											<a className="dropdown-item p-2 text-secondary px-3" href="#">Edit</a>
												<hr className="my-1"></hr> <a className="dropdown-item p-2 text-secondary px-3" href="#">Delete </a> </div>
										</div> */}
                                  </span>
                                </div>

                                <div className="balon2 p-2 m-0 position-relative">
                                  <span className="float-left sohbet2">
                                    <span>
                                      Wow that's impressive. But what's even more impressive is that
                                      this bubble is really high.{' '}
                                    </span>
                                    {/* <div className="dropdown show">
											<a id="dropdownMenuLink" data-toggle="dropdown" className="btn btn-sm float-right text-secondary dddot" role="button">
                      <img  src={AppPics.DotSvg} alt="" />
											</a>
											<div className="chatedit dropdown-menu dropdown-menu-right border p-0" aria-labelledby="dropdownMenuLink"> 
											<a className="dropdown-item p-2 text-secondary px-3" href="#">Edit</a>
												<hr className="my-1"></hr> <a className="dropdown-item p-2 text-secondary px-3" >Delete </a> </div>
										</div> */}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="w-100 card-footer p-0 bg-light border border-bottom-0 border-left-0 border-right-0">
                              <form className="m-0 p-0" action="" method="POST" autoComplete="off">
                                <div className="row m-0 p-0">
                                  <div className="col-9 m-0 p-1">
                                    <input
                                      id="text"
                                      className="mw-100 border rounded form-control"
                                      type="text"
                                      name="text"
                                      title="Type a message..."
                                      placeholder="Type a message..."
                                      required
                                    />{' '}
                                  </div>
                                  <div className="col-3 m-0 p-1">
                                    <button
                                      className="btn btn-outline-secondary rounded border w-100  replybtn"
                                      title="Gönder!"
                                    >
                                      Reply
                                    </button>
                                  </div>
                                </div>
                              </form>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Html;
